<template>
  <b-row>
    <b-col md="4">
      <InputSelectTyping
        ref="matriculaId"
        v-model="formularioFiltro.matriculaId"
        :options="opcoes.matriculas"
        :label="$t('FINANCEIRO.BUSCAR_NOME_CODIGO_MATRICULA')"
        placeholder="GERAL.DIGITE_OU_PROCURE"
        @pesquisa-nome="buscaMatriculasPorNome"
        :loading="loadingMatricula"
      />
    </b-col>
    <b-col md="4">
      <input-text
        ref="responsavel"
        v-model="formularioFiltro.responsavel"
        type="text"
        label="FINANCEIRO.RESPONSAVEL_NOME_CPF"
        placeholder="GERAL.DIGITE_OU_PROCURE"
      />
    </b-col>
    <b-col md="4">
      <input-select-multiple
        ref="statusBoletoId"
        v-model="formularioFiltro.statusBoletoId"
        :label="$t('FINANCEIRO.SITUACAO_BOLETO')"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DIGITE_OU_PROCURE"
        :options="opcoes.statusBoleto"
        :loading="loadingStatus"
      />
    </b-col>

    <b-col md="3" class="mt-3">
      <input-text
        ref="nossoNumero"
        v-model="formularioFiltro.nossoNumero"
        type="text"
        label="FINANCEIRO.NOSSO_NUMERO"
        placeholder="FINANCEIRO.NOSSO_NUMERO_PLACEHOLDER"
      />
    </b-col>
    <b-col md="3" class="mt-3">
      <input-text
        ref="seuNumero"
        v-model="formularioFiltro.seuNumero"
        type="text"
        label="FINANCEIRO.SEU_NUMERO"
        placeholder="FINANCEIRO.SEU_NUMERO_PLACEHOLDER"
      />
    </b-col>

    <!-- Filtros avançados -->
    <div class="w-100" v-if="exibirBuscaAvancada"></div>

    <!-- data de emissão -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO.DATA_EMISSAO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataEmissaoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataEmissaoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <!-- data de vencimento -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO_CONTAS_RECEBER.DATA_VENCIMENTO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataVencimentoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataVencimentoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <!-- data de pagamento -->
    <b-col md="4" v-if="exibirBuscaAvancada">
      {{ $t('FINANCEIRO_CONTAS_RECEBER.DATA_PAGAMENTO') }}
      <hr />
      <input-date-only-btn
        v-model="formularioFiltro.dataPagamentoInicio"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_INICIAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
      <input-date-only-btn
        v-model="formularioFiltro.dataPagamentoAte"
        label="FINANCEIRO_CONTAS_RECEBER.DATA_FINAL"
        placeholder="FINANCEIRO_CONTAS_RECEBER.DATA_PLACEHOLDER"
      />
    </b-col>

    <b-col md="auto" class="d-md-flex align-items-md-center">
      <input-checkbox
        variant="primary"
        class="botao-acao-filtro my-3 w-100"
        :label="$t('GERAL.BUSCA_AVANCADA')"
        v-model="exibirBuscaAvancada"
        @change="limparFiltrosAvancados"
      />
    </b-col>

    <b-col md="auto" class="d-md-flex align-items-md-center">
      <b-button
        variant="primary"
        class="botao-acao-filtro my-3 w-100"
        @click="filtrarPor"
        :disabled="!habilitarFiltragem"
      >
        {{ $t('GERAL.FILTRAR') }}
      </b-button>
    </b-col>

    <b-col md="auto" class="d-md-flex align-items-md-center">
      <b-button
        variant="secondary"
        class="botao-acao-filtro my-3 w-100"
        @click="limparFiltro"
      >
        {{ $t('GERAL.LIMPAR') }}
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';

// Services:
import BoletoPixService from '@/common/services/boleto-pix/boleto-pix.service.js';
import MatriculaService from '@/common/services/matriculas/matriculas.service.js';

// Components:
import {
  InputDateOnlyBtn,
  InputSelectMultiple,
  InputCheckbox,
  InputText,
  InputSelectTyping,
} from '@/components/inputs';

export default {
  components: {
    InputDateOnlyBtn,
    InputSelectMultiple,
    InputCheckbox,
    InputText,
    InputSelectTyping,
  },
  data() {
    return {
      loadingMatricula: false,
      loadingStatus: false,
      exibirBuscaAvancada: false,
      formularioFiltro: {},
      opcoes: {
        matriculas: [],
        statusBoleto: [],
      },
      filtroRepasse: ['statusBoletoId'],
      filtroAvancadoRepasse: [
        'dataEmissaoInicio',
        'dataEmissaoAte',
        'dataVencimentoInicio',
        'dataVencimentoAte',
        'dataPagamentoInicio',
        'dataPagamentoAte',
      ],
    };
  },
  computed: {
    habilitarFiltragem() {
      return Object.values(this.formularioFiltro).some(
        (value) => value !== null && value !== undefined && value !== ''
      );
    },
  },
  mounted() {
    this.getStatusBoleto();
  },
  methods: {
    buscaMatriculasPorNome(nome) {
      this.loadingMatricula = true;
      MatriculaService.buscarTodosPorNomeCodigo(nome)
        .then((data) => {
          if (data.itens.length) {
            this.opcoes.matriculas = data.itens;
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingMatricula = false;
        });
    },
    getStatusBoleto() {
      this.loadingStatus = true;
      BoletoPixService.buscarStatusBoleto()
        .then((data) => {
          this.opcoes.statusBoleto = data.map((row) => ({
            value: row.id,
            text: row.descricao,
          }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    criarObjetoParaFiltro() {
      return this.filtroRepasse.reduce((acc, string) => {
        acc[string] = this.formularioFiltro[string]?.value;
        return acc;
      }, {});
    },
    criarObjetoParaDeFiltroAvancado() {
      return this.filtroAvancadoRepasse.reduce((acc, string) => {
        acc[string] = this.formularioFiltro[string];
        return acc;
      }, {});
    },
    filtrarPor() {
      let filtro = this.criarObjetoParaFiltro();
      let filtroAvancado = this.criarObjetoParaDeFiltroAvancado();

      let filtros = {
        matriculaId: this.formularioFiltro?.matriculaId,
        responsavel: this.formularioFiltro?.responsavel,
        nossoNumero: this.formularioFiltro?.nossoNumero,
        seuNumero: this.formularioFiltro?.seuNumero,
        ...filtro,
        ...filtroAvancado,
      };

      this.$emit('resultado-filtro', filtros);
    },
    limparFiltrosAvancados() {
      this.filtroAvancadoRepasse.forEach((campo) => {
        if (this.formularioFiltro[campo]) delete this.formularioFiltro[campo];
      });
    },
    limparFiltro() {
      this.formularioFiltro = {};
      this.$emit('limpar');
    },
  },
};
</script>
